import React from 'react';
import { Link } from 'react-router';

class TourFlightTab extends React.Component {
  render() {
    // var tour_url = '/tour/' + {this.props.tour.id}
    return (
      <div className="col-sm-12 planner">
        <h1>Flights coming soon.</h1>
      </div>
    );
  }
}
export default TourFlightTab;



// WEBPACK FOOTER //
// src/routes/tours/components/TourFlightTab.js